"use strict";
if (!sessionStorage.getItem('vp-a-clicked')) {
    // Attendre 2 secondes (2000 millisecondes)
    setTimeout(function () {
        // Sélectionner le premier élément avec la classe 'vp-a'
        var element = document.querySelector('.vp-a');
        // Vérifier si l'élément existe
        if (element) {
            // Déclencher un clic sur l'élément
            element.click();
            setTimeout(function () {
                var videoElement = document.querySelector('video');
                console.log(videoElement);
                if (videoElement) {
                    videoElement.play().catch(function (error) {
                        videoElement.addEventListener('click', function () {
                            videoElement.play().catch(function (err) {
                                console.error('Impossible de lire la vidéo après le clic:', err);
                            });
                        });
                    });
                }
                else {
                    console.error('Aucune vidéo trouvée dans la popup.');
                }
            }, 500);
            // Marquer comme exécuté dans la session
            sessionStorage.setItem('vp-a-clicked', 'true');
        }
        else {
            console.error("Aucun élément avec la classe 'vp-a' n'a été trouvé.");
        }
    }, 2000);
}
